module.exports = __webpack_public_path__ + "static/media/dualar.69dcf8d3.png";